<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">check_circle</i>

      <h1 class="headline">Success</h1>

      <div v-if="response.status === 204">
        <p>
          <b>However.....</b>
        </p>
        <p>There were no previous submissions found.</p>

        <p>
          It may be because no submissions have been made yet, or they were
          already revoked by yourself or a co-owner of the account.
        </p>
      </div>
      <div v-else>
        <p>
          <b>All previous submissions have been revoked.</b>
        </p>

        <p>
          If your submissions were associated with an upcoming meeting then you
          may be able to vote again during the event.
        </p>
      </div>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons">close</i>
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      default() {
        return {
          status: null,
          statusText: null,
          data: {}
        };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/RevokeModal/RevokeModalSuccess.vue